import { Check, Minus } from "lucide-react";
import pricing from "@/content/pricing.json";

const Cell = ({ v, highlight }) => {
  if (v === true) return <Check className={`w-5 h-5 mx-auto ${highlight ? "text-brand-orange" : "text-brand-green"}`} aria-label="Incluido" />;
  if (v === false) return <Minus className="w-5 h-5 mx-auto text-gray-300" aria-label="No incluido" />;
  return <span className={`text-sm ${v === "0%" || v === "Ilimitado" || v === "Quitada" || v === "Todos" ? "font-semibold" : ""}`}>{v}</span>;
};

export const PlanComparison = () => {
  const names = pricing.plans.map((p) => p.name);
  const hi = pricing.plans.findIndex((p) => p.highlight);
  return (
    <div className="rounded-3xl bg-white border border-orange-100 shadow-[0_12px_40px_rgba(255,102,18,0.1)] overflow-x-auto" data-testid="plan-comparison">
      <table className="w-full min-w-[720px] border-collapse">
        <thead>
          <tr className="bg-brand-cream/70">
            <th className="text-left p-4 text-sm text-gray-500 font-heading w-[34%]">Qué incluye cada plan</th>
            {names.map((n, i) => (
              <th key={n} className={`p-4 text-center font-heading text-sm ${i === hi ? "bg-brand-carbon text-white" : "text-brand-carbon"}`}>{n}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {pricing.comparison.rows.map(([label, ...vals]) => (
            <tr key={label} className="border-t border-orange-50" data-testid="plan-comparison-row">
              <td className="p-4 text-sm font-medium text-brand-carbon">{label}</td>
              {vals.map((v, i) => (
                <td key={i} className={`p-4 text-center ${i === hi ? "bg-brand-carbon/[0.04]" : ""}`}><Cell v={v} highlight={i === hi} /></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanComparison;
